import React, { useState, useEffect } from "react";
import Adminhomemenu from "../Menus/Adminhomemenu";

export default function Createtest() {
  const user = JSON.parse(localStorage.getItem("user"));

  const [showLangModal, setShowLangModal] = useState(true);
  const [language, setLanguage] = useState("");
  const [examlanguage, setexamlanguage] = useState(user?.LANGUAGE_ID);

  const [tradeId, setTradeid] = useState(user?.TRADE_ID);
  const tradeName = user?.TRADE_NAME;
  const uid = user?.UID;

  const [testName, settestName] = useState("");
  const [batchNumber, setbatchNumber] = useState("");
  const [testDate, settestDate] = useState("");
  const [testTime, setTestTime] = useState("");
  const [numofQue, setnumofQue] = useState(20);

  const [tradedata, settradeData] = useState({ data: [] });
  const [topics, setTopics] = useState([]);
  const [showTopics, setShowTopics] = useState(false);

  const [activeTopic, setActiveTopic] = useState(null);
  const [topicQuestions, setTopicQuestions] = useState({});
  const [selectedQuestions, setSelectedQuestions] = useState([]);

  useEffect(() => {
    loadSubjects();
  }, []);

  /* ================= LANGUAGE ================= */
  const handleContinue = () => {
    if (!language) return alert("Please select language");

    setexamlanguage(language === "EN" ? "1" : language === "GU" ? "2" : "3");
    setShowLangModal(false);
  };

  /* ================= SUBJECT ================= */
  const loadSubjects = async () => {
    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LIST_OF_SUBJECT}`;
    const res = await fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ TRADE_ID: tradeId, TRADE_NAME: tradeName }),
    });
    const data = await res.json();
    settradeData(data);
    if (data?.data?.length) fetchTopics(data.data[0].TRADE_ID);
  };

  const fetchTopics = async (trade_id) => {
    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LIST_OF_TOPIC}`;
    const res = await fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ TRADE_ID: trade_id }),
    });
    const json = await res.json();
    setTopics(json.data || []);
    setSelectedQuestions([]);
    setTopicQuestions({});
    setActiveTopic(null);
  };

  /* ================= QUESTIONS ================= */
  const fetchQuestionsByTopic = async (topicId) => {
    if (topicQuestions[topicId]) {
      setActiveTopic(activeTopic === topicId ? null : topicId);
      return;
    }

    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_QUESTION1}`;
    const res = await fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        TRADE_ID: tradeId,
        TOPIC_UID: topicId,
        NUM_OF_QUE: numofQue,
        LANGUAGE_ID: examlanguage,
      }),
    });

    const json = await res.json();
    setTopicQuestions((prev) => ({
      ...prev,
      [topicId]: json.data || [],
    }));
    setActiveTopic(topicId);
  };

  /* ================= QUESTION SELECT ================= */
  const handleQuestionSelect = (queId) => {
    setSelectedQuestions((prev) => {
      if (prev.includes(queId)) {
        return prev.filter((id) => id !== queId);
      }
      if (prev.length >= numofQue) {
        alert(`Only ${numofQue} questions allowed`);
        return prev;
      }
      return [...prev, queId];
    });
  };

  /* ================= SUBMIT ================= */
  const submitFinalTest = async () => {
    if (selectedQuestions.length !== numofQue) {
      return alert(`Please select exactly ${numofQue} questions`);
    }

    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_CREATE_TEST}`;
    const res = await fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        BATCH_NUM: batchNumber,
        NUMBER_OF_Q: numofQue,
        TEST_DATE: `${testDate} 00:00:00`,
        TEST_TIME: `${testDate} ${testTime}:00`,
        QUESTION_IDS: selectedQuestions.join(","),
        UID: uid,
        LANGUAGE_ID: examlanguage,
        TEST_NAME: testName,
      }),
    });

    const data = await res.json();
    data.res === "success"
      ? alert("Test created. Code: " + data.data.TestCode)
      : alert("Something went wrong");
  };

  /* ================= UI ================= */
  return (
    <>
     <Adminhomemenu title="EasyITI" testhistory="testhistory" />

      {/* 🔹 Language Modal */}
      {showLangModal && (
        <div className="modal d-block bg-dark bg-opacity-50">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-3">
              <h5>Select Test Language</h5>
              <select
                className="form-select my-3"
                onChange={(e) => setLanguage(e.target.value)}
              >
                <option value="">-- Select --</option>
                <option value="EN">English</option>
                <option value="GU">Gujarati</option>
                <option value="HI">Hindi</option>
              </select>
              <button className="btn btn-primary" onClick={handleContinue}>
                Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 🔹 MAIN CONTENT (FIXED SCROLL) */}
      {!showLangModal && (
        <div
          style={{
            minHeight: "100vh",
            overflowY: "auto",
            paddingBottom: "40px",
          }}
        >
          <div
        className="container"
        style={{
          paddingTop: "90px",
          height: "auto",
        }}
      >
            <h4>Create Test ({language})</h4>

            <input
              className="form-control my-2"
              placeholder="Test Name"
              onChange={(e) => settestName(e.target.value)}
            />
            <input
              className="form-control my-2"
              placeholder="Batch Number"
              onChange={(e) => setbatchNumber(e.target.value)}
            />

            <select
              className="form-select my-2"
              onChange={(e) => setnumofQue(parseInt(e.target.value))}
            >
              {[20, 25, 30, 50].map((n) => (
                <option key={n}>{n}</option>
              ))}
            </select>

            <input
              type="date"
              className="form-control my-2"
              onChange={(e) => settestDate(e.target.value)}
            />
            <input
              type="time"
              className="form-control my-2"
              onChange={(e) => setTestTime(e.target.value)}
            />

            <button
              className="btn btn-primary mt-3"
              onClick={() => setShowTopics(true)}
            >
              Generate Test
            </button>

            {showTopics && (
              <>
                <div className="alert alert-info mt-3">
                  Selected: <b>{selectedQuestions.length}</b> / {numofQue}
                </div>

                {topics.map((topic) => (
                  <div className="card my-2" key={topic.TOPIC_UID}>
                    <div
                      className="card-header d-flex justify-content-between"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        fetchQuestionsByTopic(topic.TOPIC_UID)
                      }
                    >
                      {topic.TOPIC_NAME}
                      {activeTopic === topic.TOPIC_UID ? "▲" : "▼"}
                    </div>

                    {activeTopic === topic.TOPIC_UID && (
                      <div className="card-body">
                        {topicQuestions[topic.TOPIC_UID]?.map((q) => (
                          <div key={q.QUE_UID} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={selectedQuestions.includes(q.QUE_UID)}
                              onChange={() =>
                                handleQuestionSelect(q.QUE_UID)
                              }
                            />
                            <label className="form-check-label">
                              {q.QUESTION}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}

                <button
                  className="btn btn-success mt-4"
                  onClick={submitFinalTest}
                >
                  Submit Test
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
